webpackJsonp([188],{

/***/ 1167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "什么是虚拟组件(virtual component) | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1982:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1167),
  /* template */
  __webpack_require__(2371),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/what-is-vux-virtual-component-50.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] what-is-vux-virtual-component-50.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-80e6da3a", Component.options)
  } else {
    hotAPI.reload("data-v-80e6da3a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2371:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("什么是虚拟组件(virtual component)")]), _vm._v(" "), _c('h2', [_vm._v("概念")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("虚拟组件")]), _vm._v(" 是 "), _c('code', [_vm._v("VUX")]), _vm._v(" 组件特有的概念。它指的是一个组件不需要 "), _c('code', [_vm._v("import")]), _vm._v(" 就能使用，组件的代码会在编译时被 "), _c('code', [_vm._v("vux-loader")]), _vm._v(" 替换成真实的 "), _c('code', [_vm._v("html")]), _vm._v(" 代码，比如 "), _c('code', [_vm._v("x-icon")]), _vm._v(" 组件。")]), _vm._v(" "), _c('h2', [_vm._v("为什么这样实现")]), _vm._v(" "), _c('p', [_vm._v("它可以解决按需引入的问题，比如不需要把所有 "), _c('code', [_vm._v("svg")]), _vm._v(" 引入组件而是在编译时根据属性读取相应的 "), _c('code', [_vm._v("svg")]), _vm._v(" 图标直接内联。")]), _vm._v(" "), _c('p', [_vm._v("它可以解决特殊属性的赋值问题，或者自定义一些特殊写法。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-80e6da3a", module.exports)
  }
}

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1982);

/***/ })

});


// WEBPACK FOOTER //
// 188.0914b91d.js